import AssetsTable from "@hydrologiq/shared/asset/AssetsTable"
import AssetCreate from "../components/AssetCreate"
import ExpandedAssetChildrenContainer from "../components/ExpandedAssetChildrenContainer"
import type { Asset } from "@hydrologiq/gql-experience/graphql"
import type { ColumnDef } from "@tanstack/react-table"


function Assets() {
  const HeaderActions = () => {
    return (
      <AssetCreate />
    )
  }
  return (
    <AssetsTable
      headerActions={<HeaderActions />}
      expandableRows={{
        renderExpandedRows: (asset: Asset, columns: ColumnDef<Asset, any>[]) => (
          <ExpandedAssetChildrenContainer parentId={asset.id} columns={columns} />
        ),
        getRowId: (asset: Asset) => asset.id,
        isExpandable: (asset: Asset) => (asset as any).isParent === true,
      }}
    />
  )
}

export default Assets
